module.exports = __webpack_public_path__ + "static/media/computer-keyboard-blue_2.9006be49.jpg";